exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-inventory-products-edit-sources .vue-quick-edit .vue-quick-edit__input{width:80px;padding:5px;text-align:center}", ""]);

// exports
